import React from 'react';
import '../constants/AssetsCss';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment/moment';
import withRouter from '../constants/withRouter';

class CreateTicket extends React.Component {

    constructor(props) {
        super(props);
        this.createTicket = this.createTicket.bind(this);
        this.subjectChange = this.subjectChange.bind(this);
        this.messageChange = this.messageChange.bind(this);
        this.attachmentChange = this.attachmentChange.bind(this);
        this.state = {
            subject: "",
            message: "",
            attachment: ""
        }
    }

    subjectChange(e) {
        this.setState({ subject: e.target.value });
    }
    messageChange(e) {
        this.setState({ message: e.target.value });
    }
    attachmentChange(e) {
        this.setState({ attachment: e.target.files[0] });
    }

    componentDidMount() {
    }

    validate() {
        let isValid = false;
        if (!this.state.subject) {
            toast("Enter subject");
        } else if (!this.state.message) {
            toast("Enter message");
        }
        else {
            isValid = true;
        }
        return isValid;
    }

    async createTicket() {
        if (!this.validate()) {
            return;
        }
        let formdata = new FormData();
        formdata.append('message', this.state.message);
        formdata.append('topic', this.state.subject);
        if (this.state.attachment) {
            formdata.append('attachment', this.state.attachment);
        }
        let res = await GetORPostAsync("support.asp", "POST", formdata, localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        toast(res.message);
        this.setState({
            subject: "",
            message: "",
            attachment: ""
        });
    }

    render() {
        return (
            <div>
                {/* <div className="page-header">
                    <h4 className="page-title mb-0">Create Ticket</h4>
                </div> */}
                <div className="row">
                    <div className="card-body p-4">
                        <h4 className="page-title mb-0">Create Ticket</h4>
                        {/* <h5 className="card-title">Support</h5> */}
                        {/* <hr /> */}
                        <div className="form-body mt-4">
                            <div className="mb-3">
                                <label for="inputProductTitle" className="form-label">Subject</label>
                                <input value={this.state.subject} onChange={this.subjectChange} type="text" className="form-control" placeholder="Enter subject" />
                            </div>
                            <div className="mb-3">
                                <label for="inputProductTitle" className="form-label">Message</label>
                                <textarea value={this.state.message} onChange={this.messageChange} type="text" className="form-control" placeholder="Details here..." />
                            </div>
                            <div className="mb-3">
                                <label for="inputProductTitle" className="form-label">Attachments</label>
                                <input onChange={this.attachmentChange} type="file" className="form-control" />
                            </div>
                            <div className="mb-3">
                                <div className='d-grid'>
                                    <button onClick={this.createTicket} type="submit" className="btn btn-primary">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default  withRouter(CreateTicket);